export default "/images/vendor/flag-icon-css/flags/4x3/cr.svg?da71ea0e0e43752f1f4a93d992349b16";